<dx-tree-view #treeViewRef
  [items]="items"
  [dataStructure]="dataStructure"
  [keyExpr]="keyExpr"
  [parentIdExpr]="parentIdExpr"
  [displayExpr]="displayExpr"
  [searchEnabled]="searchEnabled"
  [selectionMode]="selectionMode"
  [showCheckBoxesMode]="showCheckBoxesMode"
  [selectByClick]="true"
  [height]="height"
  (onContentReady)="onContentReady($event)"
  (onSelectionChanged)="onSelectionChanged($event)">
</dx-tree-view>
